import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { router } from './router'
import store from './store'

Vue.config.productionTip = false
window.imagesLoaded = require('imagesloaded')
import '@/assets/css/tailwind.css'
import '@/assets/scss/index.scss'

import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader
import { CircleGeom, CircleStyle } from 'vuelayers'
Vue.use(CircleStyle)
Vue.use(CircleGeom)
// Vue.use(VueLayers, {
// 	projection: 'EPSG:4326'
// 	// other view properties like map center etc.
// })
Vue.use(VueLayers, {
  dataProjection: 'EPSG:4326'
  // other view properties like map center etc.
})

//-----------gql

import { ApolloClient } from 'apollo-client'
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import VueApollo from 'vue-apollo'

import { setContext } from 'apollo-link-context'

const cache = new InMemoryCache()
// const link = new HttpLink({
//   uri: 'https://graphql.fauna.com/graphql'
// })

// //covid-19-cases.herokuapp.com/v1/graphql

// https: const authLink = setContext((_, { headers }) => {
//   // get the authentication token from local storage if it exists
//   const token = process.env.VUE_APP_FAUNA
//     ? process.env.VUE_APP_FAUNA
//     : process.env.FAUNADB_SECRET
//   // return the headers to the context so httpLink can read them
//   const tokenBearer = `Basic ${token}`

//   const tokenBearer2 =
//     'Basic Zm5BRG5PUS05OEFDRXVKQkhwREtQYUIzQzlYRHZha2NkRDhzN1R6YTpjb3ZpZDE5LWNhc2VzOnNlcnZlcg=='
//   console.log(tokenBearer)
//   return {
//     headers: {
//       ...headers,
//       // authorization: token ? `Basic  ${token}` : ''
//       // authorization: `Basic Zm5BRG5McGFTaUFDRS1fWUtaWV9ScUJTaVVZQldHNy1SMFoydXB1UDpjb3ZpZDE5LWNhc2VzOnNlcnZlcg==`
//       authorization: tokenBearer2
//     }
//   }
// })

const link = new HttpLink({
  uri: 'https://covid-19-cases.herokuapp.com/v1/graphql'
})

const apolloClient = new ApolloClient({
  // link: authLink.concat(httpLink),
  fetchOptions: {
    mode: 'no-cors'
  },
  link,
  // link: authLink.concat(link),
  cache,

  // defaultOptions: defaultOptions,
  connectToDevTools: true
})
Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
